import type { InstallDepsOptions } from '@cli-types/next-adapter/init.js'
import { unique } from '@cli-utils/shared.js'
import { getDeclaredDevPackageNames } from '@next-adapter/package-json/get-declared-dev-package-names.js'
import { readProjectPackageJson } from '@next-adapter/package-json/read-project-package-json.js'
import { alignDependencySpecs } from './align-dependency-specs.js'
import { getAlignedDeclaredDependencies } from './get-aligned-declared-dependencies.js'
import { getDeclaredRuntimePackageNames } from './get-declared-runtime-package-names.js'
import { hasAlignedPackageSpec } from './has-aligned-package-spec.js'

export function resolveDependencyInstallPlan(options: InstallDepsOptions): InstallDepsOptions {
  const pkg = readProjectPackageJson(options.cwd)
  const dependencies = alignDependencySpecs(options.dependencies)
  const devDependencies = alignDependencySpecs(options.devDependencies)
  const needsPackageAlignment = [...options.dependencies, ...options.devDependencies].some(
    hasAlignedPackageSpec
  )

  if (!needsPackageAlignment) {
    return {
      ...options,
      dependencies: unique(dependencies),
      devDependencies: unique(devDependencies)
    }
  }

  return {
    ...options,
    dependencies: unique([
      ...dependencies,
      ...getAlignedDeclaredDependencies(getDeclaredRuntimePackageNames(pkg))
    ]),
    devDependencies: unique([
      ...devDependencies,
      ...getAlignedDeclaredDependencies(getDeclaredDevPackageNames(pkg))
    ])
  }
}
